const APP_CONFIG_URL = "/assets/config/app-config.json";

export type Environment = "local" | "dev" | "sit" | "bat" | "sbx" | "prd";
export interface AppConfigModel {
  apiHost?: string;
  apiBasePath?: string;
  environment?: Environment;
  shopifyApiKey?: string;
  vantageHost?: string;
  useDetached?: string; // true - allow running UI without embedding in Shopify (for local testing/debugging) purpose only, should not be used in non-local environments.
}

export interface ConfigType {
  appConfig: AppConfigModel;
  load: () => Promise<AppConfigModel> | never;
}

function createConfigService(): ConfigType {
  return {
    appConfig: {},
    load: function () {
      return fetch(APP_CONFIG_URL)
        .then((response) => response.json())
        .then((config) => {
          this.appConfig = config;
          return { ...this.appConfig };
        })
        .catch((error) => {
          throw error;
        });
    },
  };
}

const configService = createConfigService();

export default configService;
